export enum InvestigationRespondentRequestStatus {
	Pending = 1,
	Accepted = 2,
	Rejected = 3,
}
